import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '~src/modules/result/App.vue';
import router from '~src/modules/result/router';
import { installShared } from '~src/utils';
import { globalMixin } from "~src/mixins/globalMixin";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.mixin(globalMixin);

// delay mount so we can load configuration
setTimeout(() => {
  installShared(app, 'plugin_config_result');
  app.mount('#result-app');
}, 200)
